import {
  GET_USERS_START,
  GET_USERS_FULFILLED,
  GET_USERS_REJECTED,
  GET_GROUPS_START,
  GET_GROUPS_FULFILLED,
  GET_GROUPS_REJECTED,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_JOURNAL_ENTRIES_START,
  FETCH_JOURNAL_ENTRIES_FULFILLED,
  FETCH_JOURNAL_ENTRIES_REJECTED,
  FETCH_ENTRIES_FOR_ATHLETE_START,
  FETCH_ENTRIES_FOR_ATHLETE_FULFILLED,
  FETCH_ENTRIES_FOR_ATHLETE_REJECTED,
  FETCH_ENTRIES_FOR_GROUP_START,
  FETCH_ENTRIES_FOR_GROUP_FULFILLED,
  FETCH_ENTRIES_FOR_GROUP_REJECTED,
  FETCH_ME_JOURNAL_ENTRIES_START,
  FETCH_ME_JOURNAL_ENTRIES_FULFILLED,
  FETCH_ME_JOURNAL_ENTRIES_REJECTED,
  FETCH_NEXT_JOURNAL_PAGE_START,
  FETCH_NEXT_JOURNAL_PAGE_FULFILLED,
  FETCH_NEXT_JOURNAL_PAGE_REJECTED,
  CREATE_JOURNAL_ENTRIES_START,
  CREATE_JOURNAL_ENTRIES_FULFILLED,
  CREATE_JOURNAL_ENTRIES_REJECTED,
  CREATE_ENTRY_TO_ATHLETE_START,
  CREATE_ENTRY_TO_ATHLETE_FULFILLED,
  CREATE_ENTRY_TO_ATHLETE_REJECTED,
  UPDATE_JOURNAL_ENTRY_START,
  UPDATE_JOURNAL_ENTRY_FULFILLED,
  UPDATE_JOURNAL_ENTRY_REJECTED,
  DELETE_ME_JOURNAL_ENTRIES_START,
  DELETE_ME_JOURNAL_ENTRIES_FULFILLED,
  DELETE_ME_JOURNAL_ENTRIES_REJECTED,
  UPLOAD_MEDIA_START,
  UPLOAD_MEDIA_FULFILLED,
  UPLOAD_MEDIA_REJECTED,
  UPLOAD_COMMENT_MEDIA_START,
  UPLOAD_COMMENT_MEDIA_FULFILLED,
  UPLOAD_COMMENT_MEDIA_REJECTED,
  UPLOAD_COMMENT_MEDIA_URL_START,
  UPLOAD_COMMENT_MEDIA_URL_FULFILLED,
  UPLOAD_COMMENT_MEDIA_URL_REJECTED,
  CREATE_JOURNAL_ENTRY_COMMENT_START,
  CREATE_JOURNAL_ENTRY_COMMENT_FULFILLED,
  CREATE_JOURNAL_ENTRY_COMMENT_REJECTED,
  EDIT_JOURNAL_ENTRY_COMMENT_START,
  EDIT_JOURNAL_ENTRY_COMMENT_FULFILLED,
  EDIT_JOURNAL_ENTRY_COMMENT_REJECTED,
  DELETE_JOURNAL_ENTRY_COMMENT_START,
  DELETE_JOURNAL_ENTRY_COMMENT_FULFILLED,
  DELETE_JOURNAL_ENTRY_COMMENT_REJECTED,
  SUBMIT_SUPPORT_START,
  SUBMIT_SUPPORT_FULFILLED,
  SUBMIT_SUPPORT_REJECTED,
} from './actionTypes';

const initialState = {
  commentMediaLoading: {},
  groupsLoading: false,
  isEntriesLoading: true,
  isExercisesLoading: false,
  isLoadingComment: false,
  isLoadingEntry: false,
  isMediaLoading: false,
  isSupportSubmitting: false,
  nextPageLoading: false,
  usersLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_USERS_START: {
      return {
        ...state,
        usersLoading: true,
      };
    }
    case GET_USERS_FULFILLED: {
      return {
        ...state,
        usersLoading: false,
      };
    }
    case GET_USERS_REJECTED: {
      return {
        ...state,
        usersLoading: false,
      };
    }
    case GET_GROUPS_START: {
      return {
        ...state,
        groupsLoading: true,
      };
    }
    case GET_GROUPS_FULFILLED: {
      return {
        ...state,
        groupsLoading: false,
      };
    }
    case GET_GROUPS_REJECTED: {
      return {
        ...state,
        groupsLoading: false,
      };
    }
    case FETCH_EXERCISES_START: {
      return {
        ...state,
        isExercisesLoading: true,
      };
    }
    case FETCH_EXERCISES_FULFILLED: {
      return {
        ...state,
        isExercisesLoading: false,
      };
    }
    case FETCH_EXERCISES_REJECTED: {
      return {
        ...state,
        isExercisesLoading: false,
      };
    }
    case FETCH_JOURNAL_ENTRIES_START: {
      return {
        ...state,
        isEntriesLoading: true,
      };
    }
    case FETCH_JOURNAL_ENTRIES_FULFILLED: {
      return {
        ...state,
        isEntriesLoading: false,
      };
    }
    case FETCH_JOURNAL_ENTRIES_REJECTED: {
      return {
        ...state,
        isEntriesLoading: false,
      };
    }
    case FETCH_ENTRIES_FOR_ATHLETE_START: {
      return {
        ...state,
        isEntriesLoading: true,
      };
    }
    case FETCH_ENTRIES_FOR_ATHLETE_FULFILLED: {
      return {
        ...state,
        isEntriesLoading: false,
      };
    }
    case FETCH_ENTRIES_FOR_ATHLETE_REJECTED: {
      return {
        ...state,
        isEntriesLoading: false,
      };
    }
    case FETCH_ENTRIES_FOR_GROUP_START: {
      return {
        ...state,
        isEntriesLoading: true,
      };
    }
    case FETCH_ENTRIES_FOR_GROUP_FULFILLED: {
      return {
        ...state,
        isEntriesLoading: false,
      };
    }
    case FETCH_ENTRIES_FOR_GROUP_REJECTED: {
      return {
        ...state,
        isEntriesLoading: false,
      };
    }
    case FETCH_ME_JOURNAL_ENTRIES_START: {
      return {
        ...state,
        isEntriesLoading: true,
      };
    }
    case FETCH_ME_JOURNAL_ENTRIES_FULFILLED: {
      return {
        ...state,
        isEntriesLoading: false,
      };
    }
    case FETCH_ME_JOURNAL_ENTRIES_REJECTED: {
      return {
        ...state,
        isEntriesLoading: false,
      };
    }
    case FETCH_NEXT_JOURNAL_PAGE_START: {
      return {
        ...state,
        nextPageLoading: true,
      };
    }
    case FETCH_NEXT_JOURNAL_PAGE_FULFILLED: {
      return {
        ...state,
        nextPageLoading: false,
      };
    }
    case FETCH_NEXT_JOURNAL_PAGE_REJECTED: {
      return {
        ...state,
        nextPageLoading: false,
      };
    }
    case CREATE_JOURNAL_ENTRIES_START: {
      return {
        ...state,
        isLoadingEntry: true,
      };
    }
    case CREATE_JOURNAL_ENTRIES_FULFILLED: {
      return {
        ...state,
        isLoadingEntry: false,
      };
    }
    case CREATE_JOURNAL_ENTRIES_REJECTED: {
      return {
        ...state,
        isLoadingEntry: false,
      };
    }
    case CREATE_ENTRY_TO_ATHLETE_START: {
      return {
        ...state,
        isLoadingEntry: true,
      };
    }
    case CREATE_ENTRY_TO_ATHLETE_FULFILLED: {
      return {
        ...state,
        isLoadingEntry: false,
      };
    }
    case CREATE_ENTRY_TO_ATHLETE_REJECTED: {
      return {
        ...state,
        isLoadingEntry: false,
      };
    }
    case UPDATE_JOURNAL_ENTRY_START: {
      return {
        ...state,
        isLoadingEntry: true,
      };
    }
    case UPDATE_JOURNAL_ENTRY_FULFILLED: {
      return {
        ...state,
        isLoadingEntry: false,
      };
    }
    case UPDATE_JOURNAL_ENTRY_REJECTED: {
      return {
        ...state,
        isLoadingEntry: false,
      };
    }
    case DELETE_ME_JOURNAL_ENTRIES_START: {
      return {
        ...state,
        isLoadingEntry: true,
      };
    }
    case DELETE_ME_JOURNAL_ENTRIES_FULFILLED: {
      return {
        ...state,
        isLoadingEntry: false,
      };
    }
    case DELETE_ME_JOURNAL_ENTRIES_REJECTED: {
      return {
        ...state,
        isLoadingEntry: false,
      };
    }
    case UPLOAD_MEDIA_START: {
      return {
        ...state,
        isMediaLoading: true,
      };
    }
    case UPLOAD_MEDIA_FULFILLED: {
      return {
        ...state,
        isMediaLoading: false,
      };
    }
    case UPLOAD_MEDIA_REJECTED: {
      return {
        ...state,
        isMediaLoading: false,
      };
    }
    case UPLOAD_COMMENT_MEDIA_START: {
      return {
        ...state,
        commentMediaLoading: {
          loading: true,
          entryId: action.payload.entryId,
          commentId: action.payload.commentId,
        },
      };
    }
    case UPLOAD_COMMENT_MEDIA_FULFILLED: {
      return {
        ...state,
        commentMediaLoading: {},
      };
    }
    case UPLOAD_COMMENT_MEDIA_REJECTED: {
      return {
        ...state,
        commentMediaLoading: {},
      };
    }
    case UPLOAD_COMMENT_MEDIA_URL_START: {
      return {
        ...state,
        commentMediaLoading: {
          loading: true,
          entryId: action.payload.entryId,
          commentId: action.payload.commentId,
        },
      };
    }
    case UPLOAD_COMMENT_MEDIA_URL_FULFILLED: {
      return {
        ...state,
        commentMediaLoading: {},
      };
    }
    case UPLOAD_COMMENT_MEDIA_URL_REJECTED: {
      return {
        ...state,
        commentMediaLoading: {},
      };
    }
    case CREATE_JOURNAL_ENTRY_COMMENT_START: {
      return {
        ...state,
        isLoadingComment: true,
      };
    }
    case CREATE_JOURNAL_ENTRY_COMMENT_FULFILLED: {
      return {
        ...state,
        isLoadingComment: false,
      };
    }
    case CREATE_JOURNAL_ENTRY_COMMENT_REJECTED: {
      return {
        ...state,
        isLoadingComment: false,
      };
    }
    case EDIT_JOURNAL_ENTRY_COMMENT_START: {
      return {
        ...state,
        isLoadingComment: true,
      };
    }
    case EDIT_JOURNAL_ENTRY_COMMENT_FULFILLED: {
      return {
        ...state,
        isLoadingComment: false,
      };
    }
    case EDIT_JOURNAL_ENTRY_COMMENT_REJECTED: {
      return {
        ...state,
        isLoadingComment: false,
      };
    }
    case DELETE_JOURNAL_ENTRY_COMMENT_START: {
      return {
        ...state,
        isLoadingComment: true,
      };
    }
    case DELETE_JOURNAL_ENTRY_COMMENT_FULFILLED: {
      return {
        ...state,
        isLoadingComment: false,
      };
    }
    case DELETE_JOURNAL_ENTRY_COMMENT_REJECTED: {
      return {
        ...state,
        isLoadingComment: false,
      };
    }
    case SUBMIT_SUPPORT_START: {
      return {
        ...state,
        isSupportSubmitting: true,
      };
    }
    case SUBMIT_SUPPORT_FULFILLED: {
      return {
        ...state,
        isSupportSubmitting: false,
      };
    }
    case SUBMIT_SUPPORT_REJECTED: {
      return {
        ...state,
        isSupportSubmitting: false,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
